import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { formatDate } from '../../../utils/dateUtils';
import { Button } from "react-bootstrap";

const TasksOverview = () => {
  const [dates, setDates] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/get-tasks-by-date`, {
      withCredentials: true,
    }).then(res => {
      if (res.data.status) setDates(res.data.tasks);
    });
  }, []);

  return (
    <div className="container-fluid px-4 mt-4">
      <div className='row mb-3'>
        <h3>View Task</h3>
      </div>

      <div className="card shadow mt-4">
        
        <div className="card-body p-4">
          <div className="table-responsive">
            <table className="table table-bordered table-hover shadow-sm nowrap">
              <thead className="table-success">
                <tr>
                  <th>#</th>
                  <th>Date</th>
                  <th>Tasks</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {dates.map((d, idx) => (
                  <tr key={d.task_date}>
                    <td>{idx + 1}</td>
                    <td>{formatDate(d.task_date)}</td>
                    <td>{d.task_count}</td>
                    <td>
                      <Button variant="info" size="sm" onClick={() => navigate(`/overseer/tasks/view/${d.task_date}`)}>View</Button>
                        <Link to={`/overseer/tasks/print/${d.task_date}`}  className="btn btn-sm ms-1 btn-secondary"  target="_blank" >Print</Link>
                      
                    </td>
                  </tr>
                ))}
                {dates.length === 0 && (
                  <tr><td colSpan="4" className="text-center">No task dates found.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TasksOverview;
